import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "../../styles/Error.css";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";

const Errorpage = () => {
  const { language } = useContext(LanguageContext);
  return (
    <section className="error-section">
      <div className="error-page">
        <div className="error-image">
          <h3>{TEXT[language]["ERROR"]["0"]}</h3>
        </div>
        <div className="error-msg-container">
          <h4>{TEXT[language]["ERROR"]["1"]}</h4>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              justifyContent: "center",
            }}
            className="btns"
          >
            <div
              style={{
                padding: "8px",
              }}
            >
              <Link
                style={{
                  textDecoration: "underline",
                  color: "#007bff",
                }}
                to="/"
              >
                {TEXT[language]["ERROR"]["2"]}
              </Link>
            </div>
          </div>
          <p
            style={{
              marginBottom: "0",
            }}
          >
            {TEXT[language]["ERROR"]["3"]}
          </p>
          <p>{TEXT[language]["ERROR"]["4"]}</p>
        </div>
      </div>
    </section>
  );
};

export default Errorpage;
